import axios from "axios";
import { del, get, post, put } from "./api_helper";
import * as url from "./url_helper";
import * as constants from "../constants/layout"


const getLoggedInUser = () => {
  const UserInfo = localStorage.getItem("authUser");
  if (UserInfo) return JSON.parse(UserInfo);
  return null;
};

const getSessionUser = () => {
  const UserInfo = sessionStorage.getItem("sessionUser");
  if (UserInfo) return JSON.parse(UserInfo);
  return null;
};

export const userValidation = async(response) => {
  if (response && response?.data?.body?.statusFlag === 3) { // user validation
    toast.error(response.data.body.message, { autoClose: 2000 });
    localStorage.removeItem("authUser");
    window.location.reload()     
    return  
  } 
}

export const checkLoginToken = async()=>
{

  const user = getLoggedInUser()
  const sessionuser = getSessionUser()

  if(sessionuser?.UserInfo?.sessionToken){
  const params = { stid: user?.UserInfo?.stid , login_token: sessionuser?.UserInfo?.sessionToken}
  const response1 = await axios.post(url.BASE_URL+`user/checkLoginToken`, params)

  if (response1?.data?.body) {

  
    if (response1?.data?.body?.statusFlag == 2) { 
              return '0'
      // navigate("/login", { replace: true });
      // window.location.reload() 
    
    } 
    else{
      return "1"
    }
   
  } else {
    return '0'
  }
}
else{
  return '0'
}

}



//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

//getRefreshToken 
export const getRefreshToken = async() => {
  const user = getLoggedInUser()
  const params = { token: user?.UserInfo?.refreshToken }
  const response1 = await axios.post(url.BASE_URL+`master/refreshToken`, params)
  if (response1?.data?.body?.tokenReult) {
    if (response1?.data?.body?.tokenReult?.status === constants.invalidRefreshToken) {          
      localStorage.removeItem("authUser");
      window.location.reload() 
      return constants.invalidRefreshToken
    } 
    const accessToken = response1?.data?.body?.tokenReult?.accessToken
    const refreshToken = response1?.data?.body?.tokenReult?.refreshToken
    const data = Object.assign({}, UserInfo )
    data.accessToken = accessToken ? accessToken : data.accessToken
    data.refreshToken = refreshToken ? refreshToken : data.refreshToken
    localStorage.setItem('authUser', JSON.stringify(data))    
    return accessToken
  } else {
    return ''
  }
}

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
const postFakeLogin = data => post(url.POST_FAKE_LOGIN, data);

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data);

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile
};
